<template>
  <div>
    <div class="h-topo_pw2" v-show="see" :style="PositionXY">
     
      <div class="h-topo_pw_top">
        <div class="h-topo_wytb1">
          <span :class="['icon hero-icon '+icon+ ' '+online]"></span>
        </div>
        <div class="h-topo_wytb_topwz" :title='devInfo.name'>{{$t('Topo.devName')}}：{{devInfo.name}}</div>
        <div class="h-topo_wytb2">
           <span @click="click()" class="e-btn-icon icon hero-icon hero-icon-Expand"></span>
        </div>
      </div>
      <div class="h-topo_pw_bottom" v-if="seeBottom">
        <div class="topo-alarm-panelboard"  :style="styleColorVar" v-if='showAlarmNumBtn'>
          <span>{{$t('Alarm.alarm')}}:</span>   
          
          <a  style="color:dddddd;"><span class="h-icon h-icon-dot critical radius50" ></span>{{Level0AlarmCount}}</a>
          <a  style="color:dddddd;"><span class="h-icon h-icon-dot major radius50"></span>{{Level1AlarmCount}}</a>	      		      		      	
          <a  style="color:dddddd;"><span class="h-icon h-icon-dot minor radius50" ></span>{{Level2AlarmCount}}</a>
          <a  style="color:dddddd;"><span class="h-icon h-icon-dot warning radius50"></span>{{Level3AlarmCount}}</a>
			  </div>


        <div class="h-topo_wybox_panelboard">
          <div class="h-topo_wytb3"></div>
          <div class="h-topo_wytb3">
            <span class="e-btn-icon icon hero-icon hero-icon-detailed"></span>
          </div>
          <div class="h-topo_xq">{{$t('Topo.serveDetail')}}</div>
          <div class="h-topo_wytb_wz">
            <table class="h-topo_tableheight">
              <tr>
                <td>{{$t('Topo.devID')}}: {{devInfo.id}}</td>
              </tr>
              <tr>
                <td>{{$t('Topo.devType')}}: {{typeCode}}</td>
              </tr>
              <tr v-if="seeDevAttriTrunk">
                <td>{{$t('Topo.devAttriTrunk')}}: {{devInfo.softwareVersion}}</td>
              </tr>
              <tr>
                <td>{{$t('Topo.devSoftVersion')}}: {{devInfo.displaySoftwareVersion}}</td>
              </tr>
              <tr v-for="(item,i) in equipmentIPList" :key="i">
                <td>
                <table >
                <tr>
                  <td>{{$t('Topo.devIp')}}: {{item.ip}}</td>
                </tr>
                <tr>
                  <td class="h-topo-padding">{{$t('Topo.devPort')}}: {{item.port}}</td>
                </tr>
                </table>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="h-topo_btnbox_alarm row h-row-inputBox">
          <button class="e-primary e-btn" @click="alarmShowOperation">{{$t('Alarm.alarm')}}</button>
          <button class="e-primary e-btn" @click="syncConfirmFunc">{{$t('Alarm.alarmAynchronize')}}</button>
        </div>
      </div>
    </div>
    <!-- “告警弹窗展示” -->
    <CustomDialog ref="oprDialog" :element="oprSetDialog.element" :styles="oprSetDialog.styles">
      <template v-slot:dialog-content>
        <AlarmShowDialog ref='alarmDetailDialog'></AlarmShowDialog>
      </template>
    </CustomDialog>
    
  </div>
</template>
<script>
import CustomDialog from "../../components/common/CustomDialog";
import AlarmShowDialog from "../../components/topoconfig/AlarmShowDialog";
import { EventBus } from '../../plugins/eventBus';

export default {
  name: "PanelBoardShow",
  components: {
    CustomDialog,
    AlarmShowDialog
  },
  data() {
    return {
      alarmDetailObj: { id: this.id},
      typeData: [],
      typeCode: "",
      icon: "",
      online: "",
      PositionXY: "",
      devInfo: {},
      equipmentIPList: [],
      see: false,
      seeBottom: false,
      id: "",
      type: "",
      trunkName: "",
      seeDevAttriTrunk: false,
      trunkList: [],
      trunkFields: { value: "clusterId", text: "trunkName" },
      oprSetDialog: {
        element: {
          title: this.$t("Alarm.alarm"),
          target: "#app",
          isClose: true,
          refName: "oprSetDia",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: this.$t("Topo.cancel") }
            }
          ]
        },
        styles: {
          width: "1210px",
          height: "760px",
          model: true,
          visible: false,
        }
      },
      showAlarmNumBtn: { type: Boolean, default: true },
      Level0AlarmCount: 0,
      Level1AlarmCount: 0,
      Level2AlarmCount: 0,
      Level3AlarmCount: 0,
      styleColorVar:{},
    };
  },
  props: ["alarmShowObj","roleNe"],
  methods: {
    panelBoardGetData() {
      this.axios.get(`/lte/ems/topo/device/devInfoPanelDetail/${this.id}`)
        .then(response => {
          if (response.data.errorCode === "SUCCESS") {
            this.devInfo = response.data.resultVal;
            console.debug("设备",this.devInfo)
            this.equipmentIPList = this.devInfo.equipmentIPList;

        if (this.type === 10003 && null!==this.devInfo.clusterId) {
          this.seeDevAttriTrunk = true;
        }
          }
        });
    },

    // 去后台查设备类型
    queryDevType(typeCode) {
      const This = this;
      This.$axios.get(`/lte/ems/topo/device/devType/0`).then(response => {
        if (response.data === undefined) {
          return;
        }
        if (response.data.errorCode === "SUCCESS") {
          This.typeData = response.data.resultVal;
          console.debug("typeData",This.typeData)
          for (let index in This.typeData) {
            if (This.typeData[index].typeCode == typeCode) {
              this.typeCode = This.typeData[index].nameKey;
              this.icon = This.typeData[index].icon;
            }
          }
        } else if(response.status === 401) {
          EventBus.$emit('toast', {type: 'error', content: this.$t('System.loginAgain')});
        } else {
          This.typeData = [];
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
      });
    },
    click() {
      this.seeBottom = !this.seeBottom;
      this.see = !this.see;
    },

    alarmShowOperation() {
      var alarmId=this.id
      let ids = [alarmId];
      this.$axios.get(`/lte/ems/topo/netElement/${alarmId}`).then(response => {
        if (!response.data) {
          return;
        }
        if (response && response.status === 200 && response.data.errorCode === "SUCCESS") {
          if (response.data && response.data.resultVal.length > 0) {
            ids = ids.concat(response.data.resultVal);
          }
        } else if(response.status === 401) {
          EventBus.$emit('toast', {type: 'error', content: this.$t('System.loginAgain')});
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
        this.$refs.alarmDetailDialog.beforeMount(ids);
        this.$refs.oprDialog.show();
      });
    },
    dialogHide() {
      this.$refs.oprDialog.clear();
      this.$refs.oprDialog.close();
    },
    queryTopoConfig(){
			const url = "";
			this.axios.get(`/lte/ems/sysmanager/systemtopoconfig/querySystemTopoConfig`).then(response => {
				if (response && response.status === 200) {
					if(0==response.data.resultVal[0].alarmNumSet){
						this.showAlarmNumBtn = false;
					}else{
						this.showAlarmNumBtn = true;
						// this.$refs.baseBtn.queryAlarmNum();
					}
				}
			})
    },
    getAlarmCount(){
          let principal = sessionStorage.getItem('principal');
          let user = JSON.parse(principal);
          let userId = user.userId;
      if(this.roleNe.indexOf(parseInt(this.id))!=-1){
        this.$axios.post('/lte/ems/fm/alarmcurrent/alarmCount', {
          conditions: "",
          keywords: "",
          roleNe: [this.id],
          userId:userId
        }).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {

            this.Level0AlarmCount = response.data.resultVal.alarmCountInfo.criticalAlarmCount;
            this.Level1AlarmCount = response.data.resultVal.alarmCountInfo.majorAlarmCount;
            this.Level2AlarmCount = response.data.resultVal.alarmCountInfo.minorAlarmCount;
            this.Level3AlarmCount = response.data.resultVal.alarmCountInfo.warningAlarmCount;
          }
        });
      }else{
        this.Level0AlarmCount = 0;
        this.Level1AlarmCount = 0;
        this.Level2AlarmCount = 0;
        this.Level3AlarmCount = 0;
      }
			
			
    },
    // 点击同步告警按钮
    syncConfirmFunc() {
      const This = this;
      const neIdList = [this.id];
      if (neIdList) {
        This.$axios.post('/lte/ems/fm/alarmcurrent/synRule', neIdList).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.syncSuccess')});
          } else {
            EventBus.$emit('toast', {type: 'error', content: this.$t('Alarm.syncError')});
          }
        });
      } else {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.pleaseSelectNe')});
      }
    },
  },

  mounted() {
    this.styleColorVar = JSON.parse(localStorage.getItem('styleColorVar'));
    this.queryTopoConfig();
  },
  watch: {
    //父子动态传值
    alarmShowObj: {
      handler: function(newVal, oldVal) {
        var changed = (newVal.idObj != this.id) ? true : false; 
        this.see = newVal.seeObj;
        this.seeBottom = newVal.seeBottomObj;
        this.id = newVal.idObj;
        this.type = newVal.typeObj;
        if(newVal.onlineObj===1){
         	this.online='h-pm-iconOnline';
        }       
        else if(newVal.onlineObj===0){
         	this.online='h-pm-iconOffline';
        }
        
        this.PositionXY = newVal.PositionXY;	//-- panel position
          
        if(document.getElementsByClassName('h-topo_content').length > 0) //-- scroll to top  
          	document.getElementsByClassName('h-topo_content')[0].scrollTop = 0; 
        
        this.seeDevAttriTrunk = false;
        this.panelBoardGetData();
        this.queryDevType(this.type);
        this.getAlarmCount()
      },
      deep: true
    }
  }
};
</script>
<style>
div.topo-alarm-panelboard
{
	float: left;
    width: 100%;
    padding: 10px 0 10px 30px;
    color: #dddddd;
}

.topo-alarm-panelboard a
{
	margin: 0 10px 0 10px;
	color: #dddddd;
	/* cursor: pointer; */
	text-decoration: underline;
}

.topo-alarm-panelboard .radius50
{
	width: 10px !important;
    height: 10px !important;
    border-radius: 50%;
}
.h-topo_wybox_panelboard {
	position: absolute;
	margin-top: 30px;
	width: 280px;
}
.h-topo_btnbox_alarm {
	position: absolute;
	margin-top: 220px;
	margin-left: 170px;
}
.h-topo_btnbox_alarm .e-btn {
	/* width: 45px; */
	height: 25px;
	padding-left: 8px;
	padding-top: 3px;
  font-size: 12px;
  margin-right: 10px;
}
</style>
